import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { OcpwSurveyGetLinkList } from "../../../apis/OcpwSurveyDoc/OcpwSurveyDocApi";
import { observerAddToHandles } from "../../../handles/Handles";
import { OcpwGetAttachments } from "../../../apis/OcpwAttachments/OcpwAttachmentsApi";
import { OcpwGetBoxSurveyDoc } from "../../../apis/OcpwBoxDoc/OcpwBoxApi";
import axios from "axios";

//specifying type of function for the observer
type observerCallback = (setState?) => void;
//specifying type to get document api this is for QC
type getDocsFromAPIs = (
  view: {},
  OCLandInsightsID: string,
  layerId: string,
  attributes: {},
  download?: boolean
) => Promise<any>;

//exported function to set on the first render of the Payload Hook
export const setObserverCallbacks = (
  view,
  OCLandInsightsDictionary,
  setState,
  OpenPanelCheck,
  callback: observerCallback = () =>
    setObserverOnViewPopupSelectFeature(
      view,
      OCLandInsightsDictionary,
      setState,
      OpenPanelCheck
    ) //this lets us interchange the observer function
) => {
  callback();
};

//business logic to set the observer
const setObserverOnViewPopupSelectFeature = (
  view,
  OCLandInsightsDictionary,
  setState,
  OpenPanelCheck,
  getDocsFromAPIs: getDocsFromAPIs = getDocsFromMultipleAPISources //this lets us change the api function
) => {
  observerAddToHandles(
    reactiveUtils.watch(
      () => {
        return view.popup.selectedFeature;
      }, //test
      (e) => {
        if (e?.attributes) {
          const { attributes } = e;
          let layerId = getLayerId(e);
          let OCLandInsightsID = getOCLandInsightsID(e);
          if (layerId) {
            getDocsFromAPIs(
              view,
              OCLandInsightsDictionary,
              OCLandInsightsID,
              layerId,
              attributes
            ).then((ls) => {
              if (ls.length && OpenPanelCheck.mapSplit === 1) {
                OpenPanelCheck.setMapSplit(2);
              }
              setState(ls);
            });
            //setState(getDocsFromAPIs(view,layerName, attributes));
          }
        } else {
          setState([]);
        }
      }
    ),
    "docViewerWidgetHandle"
  ); //});
};

const getLayerName = (e): string | undefined => {
  let res = e as any;
  let layerName;
  if (res?.parentLayerTitle) {
    layerName = res.parentLayerTitle;
  } else {
    if (res?.layer) {
      if (res.layer.type === "feature") {
        layerName = res.layer.title;
      }
    }
  }
  return layerName;
};

const getLayerId = (e): string | undefined => {
  let res = e as any;
  let layerId;
  if (res?.parentLayerId) {
    layerId = res.parentLayerId;
  } else {
    if (res?.layer) {
      if (res.layer.type === "feature") {
        layerId = res.layer.id;
      }
    }
  }
  return layerId;
};

const getOCLandInsightsID = (e): string | undefined => {
  let res = e as any;
  let OCLandInsightsID;
  if (res?.parentCustomParameters?.OCLandInsightsID) {
    OCLandInsightsID = res.parentCustomParameters.OCLandInsightsID;
  }
  if (res?.layer?.customParameters?.OCLandInsightsID) {
    if (res.layer.type === "feature") {
      OCLandInsightsID = res.layer.customParameters?.OCLandInsightsID;
    }
  }

  return OCLandInsightsID;
};

const getDocsFromMultipleAPISources: getDocsFromAPIs = async (
  view,
  OCLandInsightsDictionary,
  OCLandInsightsID,
  layerId,
  attributes,
  download?
) => {
  let list = [];
  let ocpwSurveyDocs = OcpwSurveyGetLinkList(
    OCLandInsightsDictionary,
    OCLandInsightsID,
    attributes
  );
  let esriAttachments = await OcpwGetAttachments(view, layerId, attributes);
  let boxDocs = await OcpwGetBoxSurveyDoc(
    view,
    OCLandInsightsDictionary,
    OCLandInsightsID,
    attributes
  );
  console.log(OCLandInsightsID, ocpwSurveyDocs, esriAttachments, boxDocs);
  if (ocpwSurveyDocs.length > boxDocs.length) {
    list = list.concat(ocpwSurveyDocs.reverse(), esriAttachments);
    logMissingDocsFromBox(ocpwSurveyDocs, boxDocs);
  } else {
    list = list.concat(boxDocs.reverse(), esriAttachments);
  }
  return list;
};

const logMissingDocsFromBox = async (ocpwSurveyDocs, boxDocs) => {
  let missingDocs = "";
  let surveyDocsHashTable = {};
  for (let d = 0; d < ocpwSurveyDocs.length; d++) {
    surveyDocsHashTable[ocpwSurveyDocs[d].name] = ocpwSurveyDocs[d].name;
  }
  for (let i = 0; i < boxDocs.length; i++) {
    if (surveyDocsHashTable.hasOwnProperty(boxDocs[i].name)) {
      delete surveyDocsHashTable[boxDocs[i].name];
    }
  }
  for (const key in surveyDocsHashTable) {
    missingDocs += `${key}, `;
  }
  let data = {
    Title: "found in survey getDocs not in box",
    Message: missingDocs,
    Username: "james W",
    UserEmail: "james.wallace2@ocpw.ocgov.com",
  };
  try {
    let response = await axios.post(
      "https://prod-93.westus.logic.azure.com:443/workflows/dec41d32ae9c4d2684b1f9d12097fbf1/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=CqcRDnEbnMu2mwwXlTNfjsXBENWoy2d_I-CgjVdTNXg",
      data
    );
    console.log(response);
  } catch (error) {
    console.log(error);
  }
};
